import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

// Phone Input Form Component for LIFE Score Assessment
const PhoneInputForm = ({ onSubmit }) => {
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phoneNumber) {
      onSubmit(phoneNumber);
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto px-8 py-12">
      <div className="text-center mb-8">
        <h3 className="text-white font-medium text-xl mb-3">
          Ready to improve your LIFE score?
        </h3>
        <p className="text-white/60">
          Connect with 1440 to discuss your results and next steps
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <div>
            <style>{`
              .phone-input-dark input[type="tel"] {
                background: rgba(0, 0, 0, 0.4) !important;
                color: white !important;
                border: none !important;
              }
              .phone-input-dark input[type="tel"]::placeholder {
                color: rgba(255, 255, 255, 0.4) !important;
              }
              .phone-input-dark .PhoneInputCountrySelect {
                background: transparent !important;
                color: white !important;
                border: none !important;
              }
            `}</style>
            <div className="phone-input-dark">
              <PhoneInput
                international
                defaultCountry="US"
                value={phoneNumber}
                onChange={setPhoneNumber}
                placeholder="Enter phone number"
                className="w-full px-4 py-4 border border-white/20 rounded-xl bg-black/40 text-white focus:outline-none focus:ring-2 focus:ring-[#dcff02] focus:border-[#dcff02] backdrop-blur-sm"
                inputClassName="w-full"
              />
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={!phoneNumber}
          className="w-full relative overflow-hidden group font-medium py-4 rounded-xl text-black
          shadow-lg transition-all duration-300 ease-out transform hover:translate-y-[-2px] hover:shadow-xl
          active:translate-y-[1px] active:shadow-md active:scale-[0.98] disabled:opacity-50"
          style={{ background: "linear-gradient(to right, #b3cc02, #dcff02)" }}
        >
          <span className="relative z-10 uppercase tracking-wider text-sm font-bold">
            Get Started with 1440
          </span>

          <div className="absolute top-[-10px] left-[-10px] w-[30px] h-[30px] rounded-full blur-md opacity-70 bg-[#dcff02]" />
          <div className="absolute bottom-[-10px] right-[-10px] w-[30px] h-[30px] rounded-full blur-md opacity-70 bg-[#dcff02]" />
          <div className="absolute top-0 -left-[100%] w-[120%] h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-20deg] group-hover:animate-pulse" />
        </button>
      </form>
    </div>
  );
};

export default PhoneInputForm;
